var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestShortCodeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H5.52941V4.17647H3.17647V19.4706H5.52941V20.6471H2V3ZM18.4706 3V4.17647H20.8235V19.4706H18.4706V20.6471H22V3H18.4706ZM12.4518 11.1965C11.14 10.6871 10.5612 10.2506 10.5612 9.36118C10.5612 8.71176 11.0553 7.93647 12.3529 7.93647C13.2129 7.93647 13.8482 8.21765 14.1588 8.38824L14.4976 7.38588C14.0753 7.14588 13.3682 6.92 12.3953 6.92C10.5471 6.92 9.32 8.02118 9.32 9.50235C9.32 10.8435 10.2788 11.6471 11.8318 12.1976C13.1153 12.6906 13.6235 13.1988 13.6235 14.0871C13.6235 15.0459 12.8894 15.7106 11.6341 15.7106C10.7871 15.7106 9.98353 15.4282 9.43294 15.0894L9.12235 16.12C9.63059 16.4576 10.6318 16.7271 11.5482 16.7271C13.7918 16.7271 14.8788 15.4576 14.8788 13.9894C14.88 12.5918 14.06 11.8165 12.4518 11.1965Z",
    fill: "#0097B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestShortCodeActive);
export default __webpack_public_path__ + "static/media/test_short_code_active.0b57a6af7a330fe906cbd655304fa5eb.svg";
export { ForwardRef as ReactComponent };